<template>
  <div class="change-password">
    <div class="breadcrumb-area pos-relative mb-3">
      <h1>Thêm mới Merchant</h1>
    </div>
    <div class="mx-3 card" style="max-width: 500px">
      <div class="card-body px-20">
        <Form :form="form" @submit="onSubmit" />
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import { MerchantService } from '@/services/merchant.service'
import Form from './_form.vue'
export default {
  data () {
    return {
      showLoading: false,
      form: {
      }
    }
  },
  components: { Form },
  async created () {
  },
  methods: {
    async onSubmit (params) {
      params.agentId = this.dataUser.agentId
      try {
        this.showLoading = true
        const data = await MerchantService.create(params)
        if (data.success) {
          this.showSuccessMx('Thêm mới merchant thành công').then((s) =>
            this.$router.push('/merchant')
          )
        } else this.showFailMx(data.message)
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    }
  }
}
</script>
